function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec87a"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec87a"] = parcelRequire;
}
parcelRequire.register("cyZqS", function(module, exports) {

$parcel$export(module.exports, "register", () => $9258503fea0ee1ad$export$6503ec6e8aabbaf, (v) => $9258503fea0ee1ad$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $9258503fea0ee1ad$export$f7ad0328861e2f03, (v) => $9258503fea0ee1ad$export$f7ad0328861e2f03 = v);
var $9258503fea0ee1ad$export$6503ec6e8aabbaf;
var $9258503fea0ee1ad$export$f7ad0328861e2f03;
"use strict";
var $9258503fea0ee1ad$var$mapping = {};
function $9258503fea0ee1ad$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$9258503fea0ee1ad$var$mapping[keys[i]] = pairs[keys[i]];
}
function $9258503fea0ee1ad$var$resolve(id) {
    var resolved = $9258503fea0ee1ad$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$9258503fea0ee1ad$export$6503ec6e8aabbaf = $9258503fea0ee1ad$var$register;
$9258503fea0ee1ad$export$f7ad0328861e2f03 = $9258503fea0ee1ad$var$resolve;

});

var $436ceed037976b8f$exports = {};

(parcelRequire("cyZqS")).register(JSON.parse('{"zegSV":"index.70ed9bc3.js","107vV":"sdk.c5618277.js"}'));


//# sourceMappingURL=index.7d1a66a9.js.map
